import { useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

import { VpImage } from '@vp/common/ui/component/VpImage';
import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';

import { CommonSlideshowBlurhash } from './SlideshowContent';

interface SlideshowImageProps {
  image: ProfilePhotoModel;
}

export const SlideshowImage: FC<SlideshowImageProps> = ({ image }) => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.only('mobile'));

  const mode = isMobile ? 'cover' : 'contain';

  return (
    <VpImage
      src={image.staticUrl ?? image.url}
      hash={CommonSlideshowBlurhash}
      mode={mode}
      animateAppearance={false}
      sx={{
        height: '100%',
        width: '100%',
      }}
    />
  );
};
